//import 'babel-polyfill';
import './style.scss';
import 'src/ts/jqueryExtend';
import 'gsap/ScrollToPlugin';
import 'src/vendors/greensock-js-shockingly-green/src/bonus-files-for-npm-users/ThrowPropsPlugin.js';

import theme from 'src/scss/abstract/_variables.scss.js';

import {Wordpress} from "src/modules/helper/wordpress/wordpress";
import {SvgLoader} from 'src/modules/helper/svg.loader/svg.loader';
import {Responsive} from 'src/modules/helper/responsive/responsive';
import {Move} from 'src/modules/helper/move/move';
import {Elevator} from "src/modules/blog/blog-elevator";
import {ContactForm} from "src/modules/contact-form/contact-form";
import {Forms} from "src/modules/select/select";
import {HomeSkills} from "src/modules/home/home-skills";
import {Introduction} from "src/modules/introduction/introduction";
import {ScrollTop} from "src/modules/scroll-top/scroll-top";
import {NewsletterSubscription} from "src/modules/newsletter-subscription/newsletter-subscription";
import {LandingSEA} from "src/modules/landing-sea/landing-sea";
import {BlockMarketing} from "./modules/block-marketing/block-marketing";
import {BlockMarketingMobile} from "./modules/block-marketing/block-marketing-mobile";

$(function () {

  Wordpress.init();
  SvgLoader.init();
  Move.init();
  Responsive.init(theme.breakpoints);
  Elevator.init();
  ContactForm.init();
  Forms.init();
  HomeSkills.init();
  Introduction.init();
  ScrollTop.init();
  NewsletterSubscription.init();
  LandingSEA.init();
  BlockMarketing.init();
  BlockMarketingMobile.init();

  // Menu Blog
  let $asideMenu = $('.Aside-menu');
  if ($asideMenu.length > 0) {
    import(/* webpackChunkName: "blogMenu" */ 'src/modules/helper/sticky.sidebar/sticky.sidebar').then(module => {
      let StickySidebar = module.StickySidebar;
      let menuBlog = new StickySidebar({
        stickyElement: $asideMenu,
        endElement: $('.Footer-Top')
      });
      import(/* webpackChunkName: "blogMenu" */ 'src/modules/blog/blog-menu/blog-menu').then(module => {
        let BlogMenu = module.BlogMenu;
        BlogMenu.init();
      });
    });
  }

  let $Carousel = $('.Carousel');
  if ($Carousel.length > 0) {
    import(/* webpackChunkName: "carousel" */ 'src/modules/carousel/carousel').then(module => {
      let Carousel = module.Carousel;

      $Carousel.each(function (index: number, element: HTMLElement) {
        let carousel = new Carousel(element);
        $(element).data('carousel', carousel);
      });

    });
  }

  // Utilisés dans la page Who
  if ($('.Bubble').length > 0) {
    import(/* webpackChunkName: "bubble" */ 'src/modules/ui/bubble/bubble').then(module => {
      let Bubble = module.Bubble;
      Bubble.init();
    });
  }
  if ($('.Volet').length > 0) {
    import(/* webpackChunkName: "bubble" */ 'src/modules/ui/volet/volet').then(module => {
      let Volet = module.Volet;
      Volet.init();
    });
  }

  // Utilisés dans la page What
  if ($('.What-Navigation').length > 0) {
    import(/* webpackChunkName: "what" */ 'src/modules/what/what').then(module => {
      let What = module.What;
      What.init();
    });
  }

  // Utilisé sur la page single Skill
  if ($('.Skills-Slider').length) {

    import(/* webpackChunkName: "skill" */ 'src/modules/skills/skill').then(module => {
      let Skill = module.Skill;
      Skill.init();
    });

  }

  // Slider Skills
  let $SkillList = $('.Skills-list-section-item');
  if ($SkillList.length > 0) {
    import(/* webpackChunkName: "skill-list" */ 'src/modules/skills/skill-list').then(module => {
      let SkillList = module.SkillList;

      $SkillList.each(function (index: number, element: HTMLElement) {
        let skillList = new SkillList(element);
        $(element).data('skill-list', skillList);
      });
    });
  }


});
